<template>
  <a-modal :centered="true" v-model="showModal" :footer="null" @cancel="hide" width="587px" class="mobile-modal-fullscreen create-post-modal" :closable="false">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
      <h4 class="fw700 font24 gray700 mb-0">What did you stop taking?</h4>
      <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 cp show-in-mobile" :style="{ background: getPrimaryColor() }" @click="updateData">Update</div>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto cp font20" @click="hide" />
    </div>

    <div class="eachMedicationToggle" v-for="(medication, ind) in medicationsToToggle" :key="medication.id">
      <a-switch
        class="pl-1 pr-1 dovedailySwitch"
        :checked="medicationsToToggle[ind].taken"
        @change="handleTaken(ind)"
        :style="{
          '--P500C': getPrimaryColor().split(' ')[0],
        }"
      />
      <span class="fw700 font16 newColor ml-2">
        {{ medication.display_name }}
      </span>
      <template v-if="!medication.taken">
        <p class="font16 fw700 gray500 mt-3 mb-1">Why did you stop?</p>
        <a-select
          :allowClear="true"
          :size="'large'"
          class="w-100 stop-taking-select"
          placeholder="Reason to Stop"
          :showArrow="true"
          :filterOption="false"
          @change="handleReasonChange($event, medication.id)"
          :value="reasonToStop[medication.id]"
        >
          <a-select-option v-for="reason in stopReasons" :key="reason.id" :value="reason.name">
            {{ reason.name }}
          </a-select-option>
        </a-select>
        <a-input class="mt-4 reasonText" v-if="reasonToStop[medication.id] === 'Other'" placeholder="Write your reason" v-model="otherReason[medication.id]" />
      </template>
    </div>
    <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 mt-4 cp hide-in-mobile" :style="{ background: getPrimaryColor() }" @click="updateData">Update</div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "StopTakingModal",
  data() {
    return {
      showModal: false,
      stopReasons: [
        { name: "Doctor Recommended me to stop", id: 0 },
        { name: "I ran out of medication", id: 1 },
        { name: "i cannot afford it", id: 2 },
        { name: "My insurance denied it", id: 3 },
        { name: "Other", id: "other" },
      ],
      reasonToStop: {},
      otherReason: {},
      medicationsToToggle: [],
      posting: false,
    }
  },
  methods: {
    handleReasonChange(a, b) {
      this.reasonToStop = { ...this.reasonToStop, [b]: a }
    },
    handleTaken(i) {
      this.medicationsToToggle[i].taken = !this.medicationsToToggle[i].taken
    },
    show(name = "", oldVals, id = "") {
      this.showModal = true
      this.medicationsToToggle = oldVals.map(m => {
        this.reasonToStop[m.id] = undefined
        this.otherReason[m.id] = undefined
        return {
          ...m,
          display_name: m.treatment ? m.treatment[0].display_name : m.nonmedication.display_name,
          taken: true,
        }
      })
    },
    hide() {
      this.showModal = false
    },
    updateData() {
      if (this.posting) {
        return
      }
      this.posting = true
      Object.entries(this.reasonToStop).forEach(async v => {
        if (v[1]) {
          const editPayload = {
            reason_to_stop_treatment: this.reasonToStop[v[0]],
            other_reason_to_stop_treatment: this.otherReason[v[0]] || "",
          }
          try {
            const res = await UserRepository.editTreatments(v[0], editPayload)
            this.$notification.success({
              message: "Success",
              description: `Medication No.${v[0]} Edited`,
            })
          } catch (e) {
            console.log(e)
            this.$notification.error({
              message: "Error",
              description: `Medication No.${v[0]} could not be edited`,
            })
          }
        }
      })
      this.$router.go()
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-switch-checked {
  background: #e1eaf7;
}
.ant-switch::after {
  transform: scale(1.5) !important;
  background: #cbd5e1;
  width: 19px;
  height: 19px;
}
.ant-switch-checked::after {
  transform: translateX(-100%) scale(1.5) !important;
  background-color: var(--P500C);
}
.dovedailySwitch {
  background: #e1eaf7;
  transform: scale(0.7);
  min-width: 50px;
}
.eachMedicationToggle {
  padding: 12px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  margin-bottom: 24px;
  @media screen and (max-width: 600px) {
    margin: 12px 16px;
    padding: 12px 16px !important;
  }
}
.newColor {
  color: #585757;
}
.saveBtn {
  width: fit-content;
}
.reasonText {
  font-size: 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  height: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/dovedaily/StopTaking.vue